<script>
import Swal from '../../../js/sweetalert2.min.js';

export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            let uri = window.location.href.split('?');
            let redirectUrl = null;
            if(uri.length == 2) {
                let vars = uri[1].split('&');
                for (var i in vars) { 
                    var param = vars[i];
                    let s = param.split('=');
                    var k = s[0];
                    var v = s[1];
                    if(k == 'redirect_uri'){
                        redirectUrl = decodeURIComponent(v);
                    }
                }
            }

            if(redirectUrl == null || redirectUrl == 'signin'){
                redirectUrl = '/main';
            }
            let msg = '이미 가입한 회원입니다. \n 잠시 후 자동으로 로그인합니다.';
            
            swal(msg, {
                buttons: false,
                timer: 1500
            })
            .then(() => {
                location.replace(redirectUrl); 
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/MsgSignupExist.vue